<script lang="ts">
  import Footer from "@modern/components/retailer/reports/Footer.svelte";
  import Header from "@modern/components/retailer/reports/Header.svelte";
  import { getQueryParams } from "@modern/utils/queryparams";
  import SearchAndFilter from "@modern/components/retailer/reports/SearchAndFilter.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2";
  import ReportsTable from "@modern/components/retailer/reports/Products/ReportsTable.svelte";
  import { onMount } from "svelte";
  import moment from "moment";

  const queryParams = getQueryParams();
  let startDate =
    queryParams.get("startDate") || moment(new Date()).subtract(60, "days").format("YYYY-MM-DD");
  let endDate = queryParams.get("endDate") || moment(new Date()).format("YYYY-MM-DD");
  let search = queryParams.get("search") || "";
  let reports = [];

  const setParams = async () => {
    const searchParams = getQueryParams();
    searchParams.set("startDate", startDate);
    searchParams.set("endDate", endDate);

    search.length > 0 ? searchParams.set("search", search) : searchParams.delete("search");

    window.history.pushState(searchParams, "", `${window.location.pathname}?${searchParams}`);
  };

  const refreshData = async () => {
    await setParams();
    await fetchReports();
  };

  const fetchReports = async () => {
    if (!startDate || !endDate) return;

    try {
      reports = await HttpPromise({
        method: "GET",
        url: "/api/retailer/reports/overview_products",
        data: {
          start_date: startDate,
          end_date: endDate,
          search: search,
        },
      });
    } catch (error) {
      Flash.now({
        message: "There was an error while fetching reports overview. Please contact support",
        type: "error",
      });
    }
  };

  onMount(() => fetchReports());

</script>

<Header {startDate} {endDate} message="Top Products Report" />
<SearchAndFilter
  bind:startDate
  bind:endDate
  bind:search
  {refreshData}
  placeholder="Search Products"
/>
<ReportsTable reportsOrdersDetail={reports} {startDate} {endDate} />

<div class="fizz-styles">
  <Footer />
</div>
